import React from 'react'
import InlineSVG from 'components/InlineSVG'
import { NavLink } from 'react-router-dom'

const Menu = (props) => {
  const menu = !props.mainmenu ? false : props.mainmenu['main-menu'].map((item, idx) => (
    <li key={idx} onClick={props.onNav}>
      <NavLink to={item.link}>
        <span>{item.title}</span>
      </NavLink>
    </li>
  ))

  return (
    <ul className='header__menu'>
      {menu}
      <li className='search-toggle'>
        <InlineSVG icon='search' onClick={props.toggleSearch} />
      </li>
    </ul>
  )
}

export default Menu



// WEBPACK FOOTER //
// ./src/components/Header/MainMenu/index.js